// File: components/common/FormFields.js

import React from "react";

// Common Input Field
export const FormField = ({
  type,
  isRequierd,
  id,
  name,
  placeholder,
  label,
  value,
  onChange,
  error,
  disabled,
  maxlength,
}) => (
  <>
    <label
      htmlFor={id}
      // style={{ fontWeight: "normal" }}
      className={isRequierd ? "required" : ""}
      style={{color:" #495a69"}}
    >
      {label}
    </label>
    <input
      className={`form-control ${error ? "is-invalid" : ""}`}
      type={type}
      id={id}
      name={name}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      disabled={disabled}
      maxLength={maxlength}
      style={{
        border: " 1px solid rgb(73 90 105 / 57%)",
        padding: "16px",
        borderRadius: "12px",
      }}
    />
    {error && <div className="invalid-feedback">{error}</div>}
  </>
);

// Common Select Field
export const SelectField = ({
  id,
  isRequierd,
  name,
  label,
  selectedField,
  value,
  onChange,
  error,
  options,
}) => (
  <>
    <label htmlFor={id} className={isRequierd ? "required" : ""} style={{color:" #495a69"}}>
      {label}
    </label>
    <select
      className={`form-control ${error ? "is-invalid" : ""}`}
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      style={{
        border: " 1px solid rgb(73 90 105 / 57%)",
        height: "34px",
        borderRadius: "12px",
      }}
    >
      <option value="">{selectedField}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
    {error && <div className="invalid-feedback">{error}</div>}
  </>
);
